var _circle, _ellipse, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFailureRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FDD8D8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.9998,
    cy: 35.9999,
    rx: 24.0003,
    ry: 24.0003,
    fill: "#F54949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4142 27.5858C29.6332 26.8047 28.3668 26.8047 27.5858 27.5858C26.8047 28.3668 26.8047 29.6332 27.5858 30.4142L30.4142 27.5858ZM41.5858 44.4142C42.3668 45.1953 43.6332 45.1953 44.4142 44.4142C45.1953 43.6332 45.1953 42.3668 44.4142 41.5858L41.5858 44.4142ZM27.5858 30.4142L41.5858 44.4142L44.4142 41.5858L30.4142 27.5858L27.5858 30.4142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 41.5858C26.8047 42.3668 26.8047 43.6332 27.5858 44.4142C28.3668 45.1953 29.6332 45.1953 30.4142 44.4142L27.5858 41.5858ZM44.4142 30.4142C45.1953 29.6332 45.1953 28.3668 44.4142 27.5858C43.6332 26.8047 42.3668 26.8047 41.5858 27.5858L44.4142 30.4142ZM30.4142 44.4142L44.4142 30.4142L41.5858 27.5858L27.5858 41.5858L30.4142 44.4142Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureRedCircle);
export default __webpack_public_path__ + "static/media/failure-red-circle.e3f60bad21dd4d7117d3f8cc3a451d5f.svg";
export { ForwardRef as ReactComponent };